import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeOrder } from 'src/app/core/interfaces/production/change-order';
import { Proposal } from 'src/app/core/interfaces/proposal/proposal';
import { ApiService } from 'src/app/core/services/api/api.service';
import { IdbService } from 'src/app/core/services/idb/idb.service';
import { RoleService } from 'src/app/core/services/role/role.service';

@Component({
  selector: 'app-proposal-counts-list',
  templateUrl: './proposal-counts-list.component.html',
  styleUrls: ['./proposal-counts-list.component.scss'],
})
export class ProposalCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [
    'createdDate',
    'customer',
    'jobaddress',
    'discountedTotal',
    'assignedName',
    'proposalId',
  ];

  changeOrderDisplayedColumns: string[] = [
    'projectid',
    'customerId',
    'jobAddressId',
    'discountedTotal',
    'assignedName',
    'createdDate',
    'description',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSourceArray: Proposal[] | ChangeOrder[] = [];
  proposalDataSource: MatTableDataSource<Proposal>;
  changeOrderDataSource: MatTableDataSource<ChangeOrder>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private idb: IdbService,
    private role: RoleService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.proposalDataSource = new MatTableDataSource();
    this.changeOrderDataSource = new MatTableDataSource();
    // this.getProposals(this.status);
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getDataSource(this.status);
    });
  }

  getDataSource(status: string) {
    this.proposalDataSource = new MatTableDataSource();
    this.changeOrderDataSource = new MatTableDataSource();
    this.isLoading = true;

    if (status) {
      switch (status) {
        case 'recentUnsoldProposal':
          this.statusNumber = 0;
          this.statusMessage = 'Recent Unsold Proposals';
          break;
        case 'availableForInsideSales':
          this.statusNumber = 4;
          this.statusMessage = 'Proposals Availabile For Inside Sales';
          break;
        case 'pendingChangeOrders':
          this.statusNumber = 20;
          this.statusMessage = 'Pending Change Orders';
          break;
      }
    }

    if (this.statusNumber != undefined) {
      if (this.statusNumber !== 20) {
        if (this.role.getCurrentOfflineStatus()) {
          this.idb.getProposalsByStatus(this.statusNumber).subscribe({
            next: (response) => {
              this.isLoading = false;
              this.dataSourceArray = response;
              this.proposalDataSource = new MatTableDataSource(
                this.dataSourceArray
              );
              this.proposalDataSource.sort = this.sort;
              this.proposalDataSource.paginator = this.paginator;
            },
            error: (e) => {
              this.isLoading = false;
              console.error(e);
            },
          });
        } else {
          this.apiService.getProposalByStatus(this.statusNumber).subscribe({
            next: (response) => {
              this.isLoading = false;
              this.dataSourceArray = response;
              this.proposalDataSource = new MatTableDataSource(
                this.dataSourceArray
              );
              this.proposalDataSource.sort = this.sort;
              this.proposalDataSource.paginator = this.paginator;
            },
            error: (e) => {
              this.isLoading = false;
              console.error(e);
            },
          });
        }
      } else {
        this.apiService.getPendingChangeOrders().subscribe({
          next: (response) => {
            console.log(response);
            this.isLoading = false;
            this.dataSourceArray = response;
            this.changeOrderDataSource = new MatTableDataSource(
              this.dataSourceArray
            );
            this.proposalDataSource.sort = this.sort;
            this.proposalDataSource.paginator = this.paginator;
          },
          error: (e) => {
            this.isLoading = false;
            console.error(e);
          },
        });
      }
    }
  }

  goToProposal(row: Proposal) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        proposalId: row.proposalId,
      },
    });
    // if (this.statusNumber === 0) {
    //   this.router.navigate(['customers/' + row.customerId], {
    //     queryParams: {
    //       jobAddressId: row.jobAddressId,
    //       proposalId: row.proposalId,
    //     },
    //   });
    // } else if (this.statusNumber === 4) {
    //   this.router.navigate(['customers/' + row.customerId], {
    //     queryParams: {
    //       jobAddressId: row.jobAddressId,
    //       customerVisitId: row.customerVisitId,
    //       insideSales: true,
    //     },
    //   });
    // }
  }

  goToChangeOrder(row: ChangeOrder) {
    // Go to project info
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        projectId: row.projectid,
        projectInfo: true,
      },
    });
  }

  filterProposals(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.proposalDataSource.filter = filterString.trim().toLowerCase();
  }
}
